// Page Carte Artisans - Mobile
// Affiche la carte des artisans en plein écran

import ArtisansMapView from '../../components/maps/ArtisansMapView';

export default function MobileArtisansCartePage() {
  return (
    <div className="min-h-screen bg-gray-100" data-testid="mobile-artisans-carte-page">
      <ArtisansMapView embedded={false} />
    </div>
  );
}
